import React from 'react';

const RecipientSection = ({ recipient, isEditable, setInvoiceData }) => {
  return (
    <div className="recipient-section">
      <h4>Bill To</h4>
      <p>
        <strong>Name:</strong>
        {isEditable ? (
          <input
            type="text"
            value={recipient.name}
            onChange={(e) => setInvoiceData(prev => ({
              ...prev,
              recipient: { ...prev.recipient, name: e.target.value }
            }))}
          />
        ) : (
          <span>{recipient.name}</span>
        )}
      </p>
          <p>
            <strong>Address:</strong>{' '}
            {isEditable ? (
              <textarea
                value={recipient.address}
                onChange={(e) =>
                  setInvoiceData(prev => ({
                    ...prev,
                    recipient: { ...prev.recipient, address: e.target.value }
                  }))
                }
              />
            ) : (
              <span>{recipient.address}</span>
            )}
          </p>
          <p>
            <strong>State:</strong>{' '}
            {isEditable ? (
              <input
                type="text"
                value={recipient.state}
                onChange={(e) =>
                  setInvoiceData(prev => ({
                    ...prev,
                    recipient: { ...prev.recipient, state: e.target.value }
                  }))
                }
              />
            ) : (
              <span>{recipient.state}</span>
            )}
          </p>
          <p>
            <strong>Email:</strong>{' '}
            {isEditable ? (
              <input
                type="email"
                value={recipient.email}
                onChange={(e) =>
                  setInvoiceData(prev => ({
                    ...prev,
                    recipient: { ...prev.recipient, email: e.target.value }
                  }))
                }
              />
            ) : (
              <span>{recipient.email}</span>
            )}
          </p>
          <p>
            <strong>Phone:</strong>{' '}
            {isEditable ? (
              <input
                type="tel"
                value={recipient.contact}
                onChange={(e) =>
                  setInvoiceData(prev => ({
                    ...prev,
                    recipient: { ...prev.recipient, contact: e.target.value }
                  }))
                }
              />
            ) : (
              <span>{recipient.contact}</span>
            )}
          </p>
          <p>
            <strong>GSTIN:</strong>{' '}
            {isEditable ? (
              <input
                type="text"
                value={recipient.gstin}
                onChange={(e) =>
                  setInvoiceData(prev => ({
                    ...prev,
                    recipient: { ...prev.recipient, gstin: e.target.value }
                  }))
                }
              />
            ) : (
              <span>{recipient.gstin}</span>
            )}
          </p>
        </div>
  );
};

export default RecipientSection;